export default {
  name: "baseConfig",
  props: {
    config: {
      type: Object
    }
  },
  data: function data() {
    return {};
  }
};